module.exports = __webpack_public_path__ + "static/media/profile.8ca05271.jpg";